module.exports = __webpack_public_path__ + "static/heavy_ugl7-c1909e78ad062cb36cd314efaf949ab9.jpg";